import React from "react";
import User from "../models/user";

const UserContext = React.createContext<User | undefined>(undefined);
UserContext.displayName = "UserContext";

export default UserContext;
